<template>
    <div class="w-full">
        <div class="flex flex-wrap mt-4">
            <table v-if="itemsCurrent.length" class="table" :class="tableDark">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Llave de indetificación</th>
                        <th scope="col">Tipo</th>
                        <th scope="col flex items-align-center">Nombre</th>
                        <th scope="col flex items-align-center">
                            Sección donde es requerido
                        </th>
                        <th v-if="enabled" scope="col">
                            <div class="flex justify-center">
                                <span>⚙</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in itemsCurrent" :key="index">
                        <th scope="w-1/12">{{ index + 1 }}</th>
                        <td class="w-1/4">
                            <span>
                                {{ item.key }}
                            </span>
                        </td>
                        <td class="w-2/12">
                            <span>
                                {{
                                    $data.$productExtraOptionTypesEnum[
                                        item.type
                                    ]
                                }}
                            </span>
                        </td>
                        <td class="w-1/4">
                            <span>
                                {{ item.name }}
                            </span>
                        </td>
                        <td class="w-1/12">
                            <span>
                                {{
                                    $data
                                        .$productExtraOptionSectionWhereRequested[
                                        item.sectionWhereRequested
                                    ]
                                }}
                            </span>
                        </td>
                        <td v-if="enabled" class="w-1/12">
                            <div class="flex justify-center">
                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    :disabled="index === 0"
                                    @click="moveOrder(index, index - 1)"
                                >
                                    ⬆
                                </button>

                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    :disabled="index >= itemsCurrent.length - 1"
                                    @click="moveOrder(index, index + 1)"
                                >
                                    ⬇
                                </button>
                                <button
                                    class="btn btn-danger w-3 h-3 flex items-center justify-center"
                                    @click="deleteItem(index)"
                                >
                                    🗑️
                                </button>
                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    @click="editItem(index)"
                                >
                                    🖊
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else><span class="text-lg">No hay opciones extra</span></div>
        </div>

        <div v-if="enabled" class="flex flex-wrap">
            <div class="w-2/12"></div>
            <div class="w-8/12 flex justify-center">
                <slot name="action"></slot>
            </div>
            <div class="w-2/12">
                <custom-tooltip border>
                    <button
                        v-if="enabled"
                        class="ml-4 mt-2 border border-theme-border btn rounded-full flex justify-center items-center p-2"
                        @click="openNewFilter"
                    >
                        <span>➕</span>
                    </button>
                    <template #tooltip>
                        <span class="text-lg"> Agregar opción extra </span>
                    </template>
                </custom-tooltip>
            </div>
        </div>

        <div>
            <app-dialog v-model="isOpenModalSelectItem">
                <div class="flex flex-col items-center justify-center h-full">
                    <div class="flex flex-wrap">
                        <div class="flex flex-col w-full">
                            <span class="text-lg text-center">
                                {{
                                    isEditingItem
                                        ? "Editar opción extra"
                                        : "Agregar opción extra"
                                }}
                            </span>
                            <span class="mt-3">
                                Selecciona el tipo de opción extra que quieres,
                                configura las opciones adicionales y luego da
                                click en Guardar.
                            </span>
                        </div>
                        <div class="w-full px-2 mt-4">
                            <product-extra-option-type-selector
                                v-model="itemTemp.type"
                            />
                        </div>
                        <div class="w-1/2 px-2 mt-4">
                            <span> Llave de identificación </span>
                            <custom-input
                                id="key_"
                                v-model="itemTemp.key"
                                autocomplete="off"
                                placeholder="need-cutlery"
                                type="text"
                                name="key"
                                @input="onInputKey"
                            />
                        </div>
                        <div class="w-1/2 mt-4 px-2">
                            <span> Nombre </span>
                            <custom-input
                                id="name_"
                                v-model="itemTemp.name"
                                autocomplete="off"
                                type="text"
                                name="name"
                                placeholder="Nombre del campo solicitado"
                            />
                        </div>
                        <div class="w-full px-2 mt-4">
                            <span> Descripción </span>
                            <custom-input
                                id="name_"
                                v-model="itemTemp.summary"
                                autocomplete="off"
                                type="text"
                                name="name"
                                placeholder="Incluye una descripción para que el cliente interprete el campo solicitado"
                            />
                        </div>
                        <div class="w-1/2 mt-4 px-2">
                            <product-extra-option-requested-by-entity-selector
                                v-model="itemTemp.requestedByEntity"
                            />
                        </div>
                        <div class="w-1/2 mt-4 px-2">
                            <product-extra-option-section-where-requested-selector
                                v-model="itemTemp.sectionWhereRequested"
                            />
                        </div>
                    </div>
                    <div
                        v-if="
                            itemTemp.type === 'textChoice' ||
                            itemTemp.type === 'multiTextChoice'
                        "
                        class="my-4"
                    >
                        <p>
                            El <strong>nombre</strong> hace referencia la cadena
                            de texto que se muestra al cliente. El
                            <strong>llave</strong> es el identificador de la
                            opción debe estar escrito en formato "snake_case".
                        </p>
                        <feature-manage
                            v-model="features"
                            enabled
                            value-label="Llave"
                            @change="updateOptionsByFeatures"
                        />
                    </div>

                    <div v-if="itemTemp.type === 'imageChoice'" class="my-4">
                        <images-manage
                            v-model="images"
                            class="my-4"
                            message="opción extra"
                            default-size="squareImage"
                            :default-alt="
                                'Imagen de ' + (itemTemp.name || 'opción extra')
                            "
                            :default-filters="{ size: 'squareImage' }"
                            @change="updateOptionsByImages"
                        />
                    </div>

                    <div v-if="showDuplicate" class="mx-3 mt-2">
                        <span class="text-lg text-danger mt-4">
                            Ya tienes un opción extra con la llave
                            {{ itemTemp.key }}
                        </span>
                    </div>
                    <div class="flex justify-center mt-4">
                        <app-button
                            :disabled="isInvalidCurrentItem"
                            class="mt-3 mb-5 mx-auto"
                            border
                            gradient
                            @click="pushOrUpdateItem"
                        >
                            <span class="text-lg"> Guardar</span>
                        </app-button>
                    </div>
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { productExtraOptionRequestedByEntities } from "@/common/fields/product-extra-option-requested-by-entities";
import { productExtraOptionSectionWhereRequested } from "@/common/fields/product-extra-option-section-where-requested";
import { productExtraOptionTypesEnum } from "@/common/fields/product-extra-option-types";
import { slugify } from "@/common/lib/transformers";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import FeatureManage from "@/components/utils/FeatureManage.vue";
import ImagesManage from "@/components/utils/ImagesManage.vue";

import ProductExtraOptionRequestedByEntitySelector from "./ProductExtraOptionRequestedByEntitySelector.vue";
import ProductExtraOptionSectionWhereRequestedSelector from "./ProductExtraOptionSectionWhereRequestedSelector.vue";
import ProductExtraOptionTypeSelector from "./ProductExtraOptionTypeSelector.vue";

export default {
    name: "ProductExtraOptionsManager",
    components: {
        AppDialog,
        FeatureManage,
        ImagesManage,
        ProductExtraOptionRequestedByEntitySelector,
        ProductExtraOptionTypeSelector,
        ProductExtraOptionSectionWhereRequestedSelector,
        CustomInput
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        isOpenModalSelectItem: false,
        selectedFilters: [],
        features: [],
        images: [],
        $productExtraOptionSectionWhereRequested:
            productExtraOptionSectionWhereRequested,
        $productExtraOptionTypesEnum: productExtraOptionTypesEnum,
        itemTemp: {
            key: "",
            name: "",
            type: "",
            summary: "",
            sectionWhereRequested: productExtraOptionSectionWhereRequested.none,
            requestedByEntity: productExtraOptionRequestedByEntities.reference,
            options: []
        },
        edit: false,
        showDuplicate: false,
        isEditingItem: false
    }),
    computed: {
        ...mapGetters("control", ["tableDark"]),
        isInvalidCurrentItem() {
            return (
                !this.itemTemp.key ||
                !this.itemTemp.name ||
                !this.itemTemp.type ||
                !this.itemTemp.requestedByEntity ||
                this.showDuplicate
            );
        }
    },
    watch: {},
    methods: {
        onInputKey(value) {
            this.itemTemp.key = slugify(value);
            if (this.isEditingItem) return;
            this.showDuplicate = this.itemsCurrent.some(
                (item) => item.key === value
            );
        },
        updateOptionsByFeatures(values) {
            this.itemTemp.options = values.map((item) => ({
                key: item.value,
                name: item.name,
                value: item.value
            }));
        },
        updateOptionsByImages(values) {
            this.itemTemp.options = values.map((item) => ({
                key: `${item.id}`,
                name: item.alt,
                value: item.url
            }));
        },
        moveOrder(fromIndex, toIndex) {
            let arrAux = [...this.itemsCurrent];
            const aux = arrAux[fromIndex];
            arrAux.splice(fromIndex, 1);
            arrAux.splice(toIndex, 0, aux);
            this.$emit("change", arrAux);
        },
        editItem(fromIndex) {
            this.isEditingItem = true;
            let arrAux = [...this.itemsCurrent];
            this.itemTemp = arrAux[fromIndex];
            if (
                ["multiTextChoice", "textChoice"].includes(this.itemTemp.type)
            ) {
                this.features = this.itemTemp.options;
            } else if (["imageChoice"].includes(this.itemTemp.type)) {
                this.images = this.itemTemp.options.map((item, index) => ({
                    alt: item.name,
                    id: Number(item.key),
                    sequence: { sequence: index },
                    url: item.value
                }));
            }
            this.isOpenModalSelectItem = true;
        },
        deleteItem(fromIndex) {
            let itemsResult = [...this.itemsCurrent];
            itemsResult.splice(fromIndex, 1);
            this.$emit("change", itemsResult);
        },
        selectionFilter(id) {
            this.selectedFilters.push(id);
        },
        openNewFilter() {
            this.itemTemp = {
                key: "",
                name: "",
                type: "",
                summary: "",
                sectionWhereRequested:
                    productExtraOptionSectionWhereRequested.none,
                requestedByEntity:
                    productExtraOptionRequestedByEntities.reference,
                options: []
            };
            this.isOpenModalSelectItem = true;
        },
        pushOrUpdateItem() {
            const itemsAux = [...this.itemsCurrent];
            if (this.isEditingItem) {
                const itemAux = itemsAux.findIndex(
                    (item) => item.key === this.itemTemp.key
                );
                itemsAux[itemAux] = this.itemTemp;
                this.isEditingItem = false;
            } else {
                itemsAux.push(this.itemTemp);
            }
            this.$emit("change", itemsAux);
            this.isOpenModalSelectItem = false;
        }
    }
};
</script>
